import { LOGOUT } from "@/components/access/ducks/Actions"
import {
  CLEAR_SINGLE_USER_ACTIONS,
  CLEAR_USER_ACTIONS,
  FETCH_RECENT_USERS,
  FETCH_SINGLE_USER_ACTIONS,
  FETCH_USAGE_DATA,
  RECEIVE_COMBINED_STATS,
  RECEIVE_ENGAGEMENT_STATS,
  RECEIVE_RECENT_USERS,
  RECEIVE_SINGLE_USER_ACTIONS,
  RECEIVE_USAGE_DATA,
  SET_STAT,
  SINGLE_USER_ACTIVITY_IS_AGENT,
  UPDATE_USER_ACTIONS_FILTER,
} from "@/components/activity/admin/ducks/Actions"

const filterStats = (selectedStat, stats) => {
  const filteredStats = []
  const arrayLength = stats.length

  for (let i = 0; i < arrayLength; i += 1) {
    filteredStats.push({
      [selectedStat]: stats[i][selectedStat],
      date: stats[i].date,
    })
  }
  return filteredStats
}

const defaultState = {
  engagementStats: {},
  filteredStats: [],
  getByAgent: true,
  labels: [],
  loadingRecentActionsNextPage: false,
  loadingRecentUsersNextPage: false,
  loadingSingleUsersActionsNextPage: false,
  options: [],
  recentActions: [],
  recentActionsNextPage: 0,
  recentUsers: [],
  recentUsersNextPage: 0,
  selectedStat: "",
  singleUserActions: [],
  singleUserActionsNextPage: 0,
  stats: [],
  stopLoadingRecentUsers: false,
  stopLoadingSingleUser: false,
  stopLoadingUsageData: false,
  userActionsFilter: "NON_ADMIN_ACTIONS",
}

const adminActivityReducer = (oldState = defaultState, action) => {
  Object.freeze(oldState)
  switch (action.type) {
    case RECEIVE_USAGE_DATA: {
      const { recentActions, recentActionsNextPage, stopLoadingUsageData } = action.usageData
      const params = {
        ...oldState,
        recentActionsNextPage,
        loadingRecentActionsNextPage: false,
        stopLoadingUsageData: false,
      }

      if (recentActionsNextPage === 1) {
        params.recentActions = recentActions
      } else {
        params.recentActions = oldState.recentActions.concat(recentActions)
      }
      if (stopLoadingUsageData) {
        params.stopLoadingUsageData = true
      }
      return params
    }

    case RECEIVE_RECENT_USERS: {
      const { recentUsers, recentUsersNextPage, stopLoadingRecentUsers } = action.recentUsers
      const recentUsersParams = {
        ...oldState,
        recentUsersNextPage,
        loadingRecentUsersNextPage: false,
        stopLoadingRecentUsers: false,
      }

      if (recentUsersNextPage === 1) {
        recentUsersParams.recentUsers = recentUsers
      } else {
        recentUsersParams.recentUsers = oldState.recentUsers.concat(recentUsers)
      }
      if (stopLoadingRecentUsers) {
        recentUsersParams.stopLoadingRecentUsers = true
      }
      return recentUsersParams
    }

    case RECEIVE_COMBINED_STATS: {
      const { stats, labels } = action.combinedStats
      const combinedStatsParams = { ...oldState }
      const newLabels = []

      labels.forEach((item) => newLabels.push({ label: item, value: item }))
      combinedStatsParams.stats = stats
      combinedStatsParams.labels = labels
      combinedStatsParams.filteredStats = filterStats("Searched", stats)
      combinedStatsParams.selectedStat = "Searched"
      combinedStatsParams.options = newLabels
      return combinedStatsParams
    }

    case SINGLE_USER_ACTIVITY_IS_AGENT:
      // GetByAgent determines whether user actions are searched by agent or object
      return {
        ...oldState,
        getByAgent: action.val,
      }

    case FETCH_USAGE_DATA:
      return {
        ...oldState,
        loadingRecentActionsNextPage: true,
      }

    case FETCH_RECENT_USERS:
      return {
        ...oldState,
        loadingRecentUsersNextPage: true,
      }

    case FETCH_SINGLE_USER_ACTIONS:
      return {
        ...oldState,
        loadingSingleUsersActionsNextPage: true,
      }

    case UPDATE_USER_ACTIONS_FILTER:
      return {
        ...oldState,
        userActionsFilter: action.filter,
      }

    case CLEAR_USER_ACTIONS:
      return {
        ...oldState,
        recentActions: [],
      }

    case RECEIVE_SINGLE_USER_ACTIONS: {
      const { singleUserActions, singleUserActionsNextPage, stopLoadingSingleUser } =
        action.singleUserActions
      const singleUserActionParams = {
        ...oldState,
        singleUserActionsNextPage,
        loadingSingleUsersActionsNextPage: false,
        stopLoadingSingleUser: false,
      }

      if (singleUserActionsNextPage === 1) {
        singleUserActionParams.singleUserActions = singleUserActions
      } else {
        singleUserActionParams.singleUserActions =
          oldState.singleUserActions.concat(singleUserActions)
      }
      if (stopLoadingSingleUser) {
        singleUserActionParams.stopLoadingSingleUser = true
      }
      return singleUserActionParams
    }

    case SET_STAT:
      return {
        ...oldState,
        selectedStat: action.stat,
        filteredStats: filterStats(action.stat, oldState.stats),
      }

    case RECEIVE_ENGAGEMENT_STATS:
      return {
        ...oldState,
        engagementStats: action.stats,
      }

    case CLEAR_SINGLE_USER_ACTIONS:
      return {
        ...oldState,
        singleUserActionsNextPage: 0,
        loadingSingleUsersActionsNextPage: false,
        singleUserActions: [],
        stopLoadingSingleUser: false,
      }

    case LOGOUT:
      return defaultState

    default:
      return oldState
  }
}

export default adminActivityReducer
